export const blockIconsSearchBathroom = (
	<span className='material-symbols-outlined'>bathroom</span>
);
